<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.employee.holidayList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="row">
                    <div class="col-md-6">
                        <div class="card">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.employee.holidayList')}}</div>
                            </div>
                            <div class="card-body table-responsive p-0">
                                <table class="table table-hover" v-if="holidays.length">
                                    <thead>
                                        <tr class="header">
                                            <th>{{$t('form.employee.holiday')}}</th>
                                            <th>{{$t('form.employee.from')}}</th>
                                            <th>{{$t('form.employee.to')}}</th>
                                            <th>{{$t('form.employee.yearly')}}</th>
                                            <th class="text-right">{{$t('form.employee.action')}}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(holiday, index) in holidays" :key="index">
                                            <td>{{holiday.name}}</td>
                                            <td>{{holiday.from | formatDate(dateFormat)}}</td>
                                            <td>{{holiday.to | formatDate(dateFormat)}}</td>
                                            <td>{{holiday.yearly}}</td>

                                            <td class="text-right">
                                                <button v-if="permissions.editEmployeeHolidays"
                                                    class="btn btn-info btn-sm" @click="edit(index)">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button v-if="permissions.deleteEmployeeHolidays"
                                                    class="btn btn-danger btn-sm" @click="remove(index)">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                            </div>

                            <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                                @paginate="paginate()">
                            </pagination>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="card" v-if="toggleForm">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.employee.holidayCreate')}}</div>
                                <b-button class="float-right" variant="primary" @click="submit">{{$t('button.save')}}
                                </b-button>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>{{$t('form.employee.holiday')}}<span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" v-model="name">
                                </div>

                                <div class="form-group">
                                    <b-form-checkbox id="yearly-check" v-model="yearly">
                                        {{$t('form.employee.setYearly')}}
                                    </b-form-checkbox>
                                </div>

                                <template v-if="yearly">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.date')}}<span class="text-danger">*</span></label>
                                        <b-input v-model="date" placeholder="01.01.*"></b-input>
                                    </div>
                                </template>

                                <template v-else>
                                    <div class="form-group">
                                        <label>{{$t('form.employee.from')}}<span class="text-danger">*</span></label>
                                        <date-picker :lang="lang" class="date-picker" v-model="from" valueType="format"
                                            :format="dateFormat" :popup-style="{ top: '100%', left: 0}"
                                            :append-to-body="false">
                                        </date-picker>
                                    </div>

                                    <div class="form-group">
                                        <label>{{$t('form.employee.to')}}<span class="text-danger">*</span></label>
                                        <date-picker :lang="lang" class="date-picker" v-model="to" valueType="format"
                                            :format="dateFormat" :popup-style="{ top: '100%', left: 0}"
                                            :append-to-body="false">
                                        </date-picker>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div class="card" v-else>
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.employee.holidayEdit')}}</div>
                                <div class="text-right">
                                    <b-button variant="outline-primary" @click="reset">{{$t('button.cancel')}}
                                    </b-button>
                                    <b-button variant="primary" @click="update">{{$t('button.update')}}</b-button>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>{{$t('form.employee.holiday')}}<span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" v-model="name">
                                </div>

                                <div class="form-group">
                                    <b-form-checkbox id="yearly-check" v-model="yearly">
                                        Set as Yearly?
                                    </b-form-checkbox>
                                </div>

                                <template v-if="yearly">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.date')}}<span class="text-danger">*</span></label>
                                        <b-input v-model="date" placeholder="01.01.*"></b-input>
                                    </div>
                                </template>

                                <template v-else>
                                    <div class="form-group">
                                        <label>{{$t('form.employee.from')}}<span class="text-danger">*</span></label>
                                        <date-picker :lang="lang" class="date-picker" v-model="from" valueType="format"
                                            :format="dateFormat" :popup-style="{ top: '100%', left: 0}"
                                            :append-to-body="false">
                                        </date-picker>
                                    </div>

                                    <div class="form-group">
                                        <label>{{$t('form.employee.to')}}<span class="text-danger">*</span></label>
                                        <date-picker :lang="lang" class="date-picker" v-model="to" valueType="format"
                                            :format="dateFormat" :popup-style="{ top: '100%', left: 0}"
                                            :append-to-body="false">
                                        </date-picker>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions', 'dateFormat'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,
                toggleForm: true,

                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },

                pagination: {
                    current_page: 1
                },

                id: '',
                name: '',
                from: null,
                to: null,
                yearly: false,
                date: null,

                holidays: []
            }
        },

        mounted() {
            if (!this.permissions.viewEmployeeHolidays) {
                return this.$router.push('/');
            }

            this.getHolidays();
        },

        methods: {

            getHolidays() {
                this.isLoading = true;

                axios
                    .get('/api/holidays?page=' + this.pagination.current_page)
                    .then(response => {
                        this.holidays = response.data.data.data;
                        this.pagination = response.data.pagination;

                        this.isLoading = false;
                    })
                    .catch(error => {
                        console.log('error fetching local holidays');

                        this.isLoading = false;
                    });
            },

            paginate() {
                this.getHolidays();
            },

            async submit() {

                if (!await this.validate()) return;

                this.clear();
                this.isLoading = true;

                axios
                    .post('/api/holidays', this.getFormData())
                    .then(response => {

                        if (response.data.success) {
                            this.reset();

                            this.showAlert(response.data.message);
                            this.holidays.unshift(response.data.data);

                        }

                        this.isLoading = false;
                    })
                    .catch(error => {
                        console.log('error saving local holiday.');

                        if (error.response.status == 422 && error.response.data.message) {
                            this.showAlert(error.response.data.message, 'danger');
                        }

                        this.isLoading = false;
                    });
            },

            edit(index) {
                this.id = this.holidays[index].id;
                this.name = this.holidays[index].name;

                if (this.holidays[index].from)
                    this.from = moment(this.holidays[index].from).format(this.dateFormat);

                if (this.holidays[index].to)
                    this.to = moment(this.holidays[index].to).format(this.dateFormat);

                if (this.holidays[index].yearly) {
                    this.yearly = true;
                    this.date = this.holidays[index].yearly;
                }

                this.toggleForm = false;
            },

            async update() {

                if (!await this.validate()) return;

                this.clear();
                this.isLoading = true;

                axios
                    .put(`/api/holidays/${this.id}`, this.getFormData())
                    .then(response => {
                        if (response.data.success) {
                            this.showAlert(response.data.message);

                            this.holidays.map(r => {
                                if (r.id == this.id) {
                                    // r.id = response.data.data.id;
                                    r.name = response.data.data.name;
                                    r.from = response.data.data.from;
                                    r.to = response.data.data.to;
                                    r.yearly = response.data.data.yearly;
                                }
                            });

                            this.reset();
                        } else if (response.data.error) {
                            this.showAlert(response.data.message, 'danger');
                        }

                        this.isLoading = false;
                    })
                    .catch(error => {
                        console.log('error updating local holiday.');

                        this.isLoading = false;
                    })
            },

            validate() {
                if (this.name == '') {
                    this.showAlert(this.$t('form.validation.error'), 'danger');
                    return false;
                }

                if ((this.from == null || this.to == null) && !this.yearly) {
                    this.showAlert(this.$t('form.validation.error'), 'danger');
                    return false;
                }

                if (this.yearly && this.date == null || this.date == '') {
                    this.showAlert(this.$t('form.validation.error'), 'danger');
                    return false;
                }

                // validate to date must be greater than from date
                if (moment(this.from, this.dateFormat) > moment(this.to, this.dateFormat)) {
                    this.showAlert(this.$t('form.validation.greater'), 'danger');
                    return false;
                }

                // check for valid yearly date string
                if (this.yearly && !/^([0-2][0-9]|(3)[0-1])(\.)(((0)[0-9])|((1)[0-2]))(\.\*)$/.test(this.date)) {
                    this.showAlert(this.$t('form.validation.invalidDate'), 'danger');
                    return false;
                }

                return true;
            },

            getFormData() {
                return {
                    name: this.name,
                    from: this.yearly ? null : this.from,
                    to: this.yearly ? null : this.to,
                    yearly: this.date,
                };
            },

            reset() {
                this.id = null;
                this.name = '';
                this.from = null;
                this.to = null;
                this.yearly = false;
                this.date = null;

                this.toggleForm = true;
            },

            remove(index) {
                if (confirm(this.$t('form.validation.delete'))) {

                    this.clear();
                    this.isLoading = true;

                    axios
                        .delete(`/api/holidays/${this.holidays[index].id}`)
                        .then(response => {
                            if (response.data.success) {
                                this.showAlert(response.data.message);
                                this.holidays.splice(index, 1);
                            } else if (response.data.error) {
                                this.showAlert(response.data.message, 'danger');
                            }

                            this.isLoading = false;
                        })
                        .catch(error => {
                            console.log('error deleting holiday.');

                            this.isLoading = false;
                        })
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },

            clear() {
                this.alert = false;
                this.message = '';
                this.alertClass = '';
            }
        }
    }

</script>

<style scoped>
    .date-picker {
        display: block;
        width: 100% !important;
    }

</style>
